import {Footer, Reset} from "../../components";
import React from "react";

export default function ResetPage() {
    return (
        <div>
            <Reset/>
            <Footer/>
        </div>
    )
}
